/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState, ProductState, StraussLogoType } from '../store/interfaces';

import { Editscreen } from '../components/Editscreen'
import { uiGoTo,  configStoreFetch, uiSetVat, configUpdateProduct, configRemoveProduct, configAddProduct, configSetBaseColor, configSetContrastColor, configSetStraussLogo, uiSetPreviewArticle1, uiSetPreviewArticle2, configStoreLogoFetch, configDeleteLogoFetch, uiSetEditScreenTab, uiSetDetailArticleIndex } from '../store/actions';

const mapStateToProps = (state: ApplicationState) => {
    return {
        config: state.config,
        ui: state.ui,
        library: state.library
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiGoTo: (route: string) => {
            dispatch(uiGoTo(route));
        },
        onUiSetPreviewArticle1: (article: string) => {
            dispatch(uiSetPreviewArticle1(article));
        },
        onUiSetPreviewArticle2: (article: string) => {
            dispatch(uiSetPreviewArticle2(article));
        },
        onUiSetDetailArticleIndex: (detailArticleIndex: number) => {
            dispatch(uiSetDetailArticleIndex(detailArticleIndex));
        },
        onUiSetEditScreenTab: (editScreenTab: string) => {
            dispatch(uiSetEditScreenTab(editScreenTab));
        },
        onProductAdd: (article: string, size: string) => {
            dispatch(configAddProduct(article, size));
            dispatch(configStoreFetch());
        },
        onProductUpdate: (index: number, state: ProductState) => {
            dispatch(configUpdateProduct(index, state));
            dispatch(configStoreFetch());
        },
        onProductRemove: (index: number) => {
            dispatch(configRemoveProduct(index));
            dispatch(configStoreFetch());
        },
        onConfigSetBaseColor: (colorId: string) => {
            dispatch(configSetBaseColor(colorId));
        },
        onConfigSetContrastColor: (colorId: string) => {
            dispatch(configSetContrastColor(colorId));
        },
        onConfigSetStraussLogo: (logo: StraussLogoType) => {
            dispatch(configSetStraussLogo(logo));
        },
        onConfigStoreLogo: (logo: any) => {
            dispatch(configStoreLogoFetch(logo));
        },
        onConfigDeleteLogo: (filename: string) => {
            dispatch(configDeleteLogoFetch(filename));
        },
        onUiSetVat: (vat: boolean) => {
            dispatch(uiSetVat(vat));
        }
    }
}

const EditscreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Editscreen)

export default EditscreenContainer
